import { render, staticRenderFns } from "./AutoResponseEditor.vue?vue&type=template&id=2efbc8c1&scoped=true&"
import script from "./AutoResponseEditor.vue?vue&type=script&lang=js&"
export * from "./AutoResponseEditor.vue?vue&type=script&lang=js&"
import style0 from "./AutoResponseEditor.vue?vue&type=style&index=0&id=2efbc8c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbc8c1",
  null
  
)

export default component.exports